export const HOME_PAGE_ALTERNATE_CARDS = {
  heading: 'We build a better financial future for you',
  cards: [
    {
      title: 'Have an experienced investment team work for you',
      description:
        'Each mutual fund on ClearTax is chosen by our investment research team based on an investment methodology proven by decades of research',
      image: `/clearsave/images/scientist.svg`,
    },
    {
      title: 'Power your financial life with technology',
      description:
        'Our software manages your investment account for you 24/7, around the clock. We will do all the work so that you can focus on the other things that really matter',
      image: `/clearsave/images/magic.svg`,
    },
    {
      title: 'Easy access to keep yourself always on course',
      description:
        'View all of your investment in one place, have complete transparency of every transaction you make, withdraw when you need the money',
      image: `/clearsave/images/tvman.svg`,
    },
  ],
};

export const HOME_PAGE_NFO_SECTION_CONTENT = {
  heading: 'New Fund Offers (NFO)',
  subtitle: 'Early investment opportunity to invest in newly launched funds',
  anchorText: 'View all NFOs →',
  anchorLink: '/mutual-funds/nfo',
};

export const HOME_PAGE_WHY_US_SECTION_CONTENT = {
  heading: 'Why Invest with ClearTax',
  subtitle: '',
  cards: [
    {
      title: 'Choose from best funds',
      description: 'Invest in hand-picked top performing Mutual funds',
      image: `/clearsave-frontend/images/star.svg`,
    },
    {
      title: 'Easy to invest',
      description: 'Sign up and start investing online within minutes.',
      image: `/s/img/2018/06/10122924/money-growth1.png`,
    },
    {
      title: 'Easy to track',
      description: 'Track / monitor your investments 24/7 on your dashboard',
      image: `/s/img/2018/06/10122922/stock1.png`,
    },
    {
      title: 'Bank graded security',
      description:
        'Data security is our top priority. 128 Bit Bank Grade SSL. ISO 27001 Data Centers.',
      image: `/s/img/2018/06/10122916/safe1.png`,
    },
    {
      title: 'Easy to withdraw',
      description: 'Withdraw anytime in 1-click with no paperwork needed',
      image: `/s/img/2018/06/10122920/payment-1.png`,
    },
    {
      title: 'Instant investment proof',
      description: 'Get your 80C investment proof instantly and submit to HR.',
      image: `/s/img/2018/06/10122914/award-491.png`,
    },
  ],
};

export const HOME_PAGE_PARTNERS_CONTENT = {
  title: 'Some of our fund partners',
  partners: [
    {
      author: 'bslmf',
      image: `/clearsave/images/bslmf-gray-new.png`,
    },
    {
      author: 'reliance',
      image: `/clearsave/images/reliance-gray-new.svg`,
    },
    {
      author: 'dsp',
      image: `/clearsave/images/dsp-gray-new.svg`,
    },
    {
      author: 'hdfc',
      image: `/clearsave/images/hdfc-gray-new.svg`,
    },
    {
      author: 'icici',
      image: `/clearsave/images/icici-gray-new.svg`,
    },
    {
      author: 'axis',
      image: `/clearsave/images/axis-gray-new.svg`,
    },
  ],
  testimonials: [
    {
      testimonial:
        'With the e-KYC feature on ClearTax, users no longer have to worry about providing a bunch of documents for KYC fulfilment, but can simply sit back and experience a quick, smooth and paperless registration process.',
      author: 'The Hindu',
      image: `/clearsave/images/hindu.jpg`,
      link: 'http://www.thehindu.com/business/Industry/cleartaxs-e-kyc-to-help-mf-investors/article19988029.ece',
    },
    {
      testimonial:
        'One of the biggest pain-points that taxpayers face at the time of filing income tax returns is struggling through the technical terms and jargon associated with income tax...But that was until ClearTax came into the picture.Just by itself, ClearTax solved all of these problems for taxpayers.',
      author: 'Business Standard',
      image: `/clearsave/images/business_standard_new.jpg`,
      link: 'http://www.business-standard.com/content/specials/how-cleartax-has-made-tax-filing-really-easy-117071100368_1.html',
    },
    {
      testimonial:
        'In five years, ClearTax has taken a large share of the market, beating older players such as TaxSpanner, MyITReturns, Tax2Win, and TaxChanakya...the company has scored over its competitors because of the “strong product and technology background” of its founders.',
      author: 'Fortune India',
      image: `/clearsave/images/fortune_india.jpg`,
      link: 'http://www.fortuneindia.com/ideas/archit-gupta-making-income-tax-returns-easier/100230',
    },
    {
      testimonial:
        'Clear Tax has created a Form 16 parser (a software program) where the user has to just upload Form 16 and all the data from the PDF is auto populated at appropriate places on the software...This helps, especially in the case of individuals with only salary income and additionally having a home loan where return is being serviced.',
      author: 'Economic Times',
      image: `/clearsave/images/economic_times.png`,
      link: 'https://economictimes.indiatimes.com/wealth/tax/e-filing-itr-govts-income-tax-website-or-private-websites/articleshow/59283676.cms',
    },
  ],
  testimonialsRollSpeed: 3,
};

export const HOME_PAGE_SECURITY_CONTENT = {
  title: 'We are serious about your data security',
  description:
    'Data security is our top priority as a tax company. 128 Bit Bank Grade SSL. ISO 27001 Data Centers.',
  image: `/clearsave/images/shield.png`,
};

export const HOME_PAGE_RESOURCES = {
  title: 'We have great resources for you to get started',
  subTitle: 'Frequent Asked Questions',
  links: [
    {
      question:
        'What are the benefits of investing in tax-saving mutual funds?',
      answer:
        'Investments in tax-saving mutual funds, also known as Equity Linked Savings Schemes (ELSS), can get you a tax break of up to ₹1.5 lakh under Section 80C of the Income Tax Act. ',
    },
    {
      question: 'Why should I choose ELSS over other tax-saving investments?',
      answer:
        'In comparison to other tax-saving investments, ELSS funds come with the lowest lock-in period of only 3 years. Additionally, these are equity mutual funds, which means they have the ability to earn high returns over the long-term.',
    },
    {
      question: 'Do ELSS funds have additional tax benefits?',
      answer:
        'Tax-saving mutual funds come with the dual benefit of tax saving and wealth creation. They help you not only save taxes but build wealth over the long-term as well, because these mutual funds invest primarily in equities and earn higher returns than traditional tax-saving investments like PPF, FDs and NSC. ',
    },
    {
      question: 'Will my money get locked in when I invest in ELSS funds?',
      answer:
        'Not only ELSS funds, all tax-saving investments come with a lock-in period. But tax-saving mutual funds have the lowest lock-in period of only 3 years. In comparison, PPF has a lock-in of 15 years, while NPS and EPF require you to be invested till you retire. ',
    },
    {
      question: 'What are SIPs?',
      answer:
        'SIPs are Systematic Investment Plans where money is deducted from your bank account and invested automatically. With an SIP, you’re able to purchase fund units at different levels of the market and benefit from rupee cost averaging.',
    },
    {
      question: 'Why are SIPs said to be better than lump sum investments?',
      answer:
        'Using an SIP, you’re able to invest regularly every month. By spreading out your investment like this, instead of investing the whole amount in one go, you can cushion yourself from catching a market peak. Furthermore, SIPs also provide the benefit of getting into a habit of saving and investing every month.',
    },
    {
      question: 'How should I select mutual funds to invest in?',
      answer:
        "After rigorous modeling we choose the the right mix of funds that is best suited for your needs. We look at fund’s past returns, fund manager’s performance, it's consistency, performance against it’s peers among other things to shortlist the funds. ",
    },
    {
      question: 'Who gets the money that I invest through ClearTax?',
      answer:
        'Your money goes directly to the accounts of the mutual funds that you invest in. it does not come to ClearTax. At the time of redemption, the money will be transferred by the fund company and deposited directly to your bank account. ',
    },
    {
      question: 'How much do I need to invest in mutual funds?',
      answer:
        'There is no fixed amount that you need to invest every year in a mutual fund. Most funds have a minimum investment ₹1000, but the cumulative yearly investment can be as per your convenience. On ClearTax you can start investing with just ₹ 3000. ',
    },
    {
      question: 'How much does ClearTax charge?',
      answer:
        'ClearTax is completely free for you. We do not charge any commission from our users. We get a commission from funds that helps us keep our service free and high quality.',
    },
    {
      question: 'How to redeem the investment?',
      answer:
        'You can withdraw your investments anytime from your ClearTax Investment Dashboard. After redemption, the money is usually transferred to your registered bank account directly within 4-5 working days. Tax saving funds (ELSS) have a 3 year lock-in after which you can redeem. You can redeem only those ELSS fund units (investments) that have completed a lock-in period of three years.',
    },
    {
      question: 'Is it safe to invest via ClearTax?',
      answer:
        'ClearTax is registered with the Association of mutual funds (AMFI) under ARN code: ARN110027. Your investments made through ClearTax are 100% genuine. All data and transactions are protected with 128 bit encryption. ',
    },
    {
      question: 'Can I invest more later?',
      answer:
        'Yes of course. You can make additional investments anytime from your investment dashboard. Pay from your registered bank account using net banking or debit card.',
    },
    {
      question: 'How can I pay less tax?',
      answer:
        'When you invest money in Tax Saving funds during the year, the amount of tax you have to pay in the year is decreased. Also, you keep earning returns in amount invested.',
    },
    {
      question: 'How much should I invest in tax saving?',
      answer: 'You can invest up to Rs.1.5 Lakh under section 80C.',
    },
    {
      question: 'Till when can I finish my tax saving?',
      answer:
        'You should finish all your tax saving investments by March 31st to reduce the amount of tax you pay this year.',
    },
    {
      question: 'What are the different tax saving options?',
      answer:
        'You have many options like PPF, Insurance, Tax Saving FDs, Tax Saving Mutual funds (also called ELSS) etc.',
    },
    {
      question:
        'Do I need to get KYC done to invest in tax-saving mutual funds?',
      answer:
        'Yes. Know Your Customer (KYC) compliance is mandatory to invest in ELSS funds. But unlike what you would think, KYC is not a difficult process. ClearTax has a completely paperless process for KYC which can be completed online.',
    },
    {
      question: 'Which documents do I need for KYC?',
      answer: `The documents required for KYC are:
- 1 passport size photograph
- 1 copy of PAN
- 1 address proof
With these documents, the entire KYC process can be done online when you invest through ClearTax.`,
    },
  ],
};

export const HOME_PAGE_FEATURED = {
  title: 'Featured Articles',
  articles: [
    {
      title: 'SIP or lump sum',
      link: 'https://cleartax.in/s/sip-lump-sum-invest-mutual-funds/',
    },
    {
      title: 'Debt funds better than FDs',
      link: 'https://cleartax.in/s/debt-mutual-funds-better-fixed-deposits/',
    },
    {
      title: 'How to choose a mutual fund',
      link: 'https://cleartax.in/s/ask-three-questions-choose-mutual-fund/',
    },
    {
      title: 'Are mutual funds safe',
      link: 'https://cleartax.in/s/mutual-funds-safe/',
    },
  ],
};

export * from './freeComponentData';



// WEBPACK FOOTER //
// ./constants/homePageStatic.ts